import React, { Component } from "react";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { clickMenuOpen } from "../../../redux/actions";
import Autenticador from "../../../servicios/Autenticador";

import logo from "../../../assets/img/LogoCC.png";

class Sidebar extends Component {

  render() {
    const { clickMenuOpen, toggled } = this.props;
    return (
      <ul
        className={
          toggled
            ? "navbar-nav bg-gradient-primary sidebar sidebar-dark accordion toggled"
            : "navbar-nav bg-gradient-primary sidebar sidebar-dark accordion"
        }
        id="accordionSidebar"
      >
        {/* <!-- Sidebar - Brand --> */}
        <Link
          className="sidebar-brand d-flex align-items-center justify-content-center"
          to="/Inicio"
        >
          <img
            className="sidebar-brand-logo"
            src={logo}
            aria-label="Centro de Información Crediticia para el Ciudadano"
          />
        </Link>

        {/* <!-- Divider --> */}
        <hr className="sidebar-divider" />

        {/* <!-- Heading --> */}
        <div className="sidebar-heading">Menú</div>

        {/* <!-- Nav Item - Reporte Crediticio --> */}
        <li className="nav-item">
          <Link className="nav-link" to="/Inicio/">
            <i className="fas fa-fw fa-file-alt"></i>
            <span>Reporte Crediticio</span>
          </Link>
        </li>

        {/* <!-- Divider --> */}
        <hr className="sidebar-divider" />

        {/* <!-- Nav Item - Cerrar Sesión --> */}
        <li className="nav-item">
          <button
            className="btn btn-link nav-link"
            onClick={Autenticador.cerrarSesion}
          >
            <i className="fas fa-fw fa-sign-out-alt"></i>
            <span>Cerrar Sesión</span>
          </button>
        </li>

        {/* <!-- Divider --> */}
        <hr className="sidebar-divider d-none d-md-block" />

        {/* <!-- Sidebar Toggler (Sidebar) --> */}
        <div className="text-center d-none d-md-inline">
          <button
            onClick={() => {
              clickMenuOpen();
            }}
            className="rounded-circle border-0"
            id="sidebarToggle"
          ></button>
        </div>
      </ul>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ clickMenuOpen }, dispatch);

const mapStateToProps = (store) => ({
  toggled: store.menuState.menuOpen,
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
